import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {IntroductionComponent} from './Introduction/Introduction.component';
import {HomeRoutes} from './Home.routing';
import {WidgetsModule} from '../../Widgets/Widgets.module';
import {TemplateModule} from '../../Template/Template.module';
import {TranslateModule} from '@ngx-translate/core';
import {OurFoodComponent} from './OurFood/OurFood.component';
import {SliderSpecialComponent} from './SliderSpecial/SliderSpecial.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {SliderDimsumComponent} from './SliderDimsum/SliderDimsum.component';
import {SliderHotpotComponent} from './SliderHotpot/SliderHotpot.component';

@NgModule({
  declarations: [
    IntroductionComponent,
    OurFoodComponent,
    SliderSpecialComponent,
    SliderDimsumComponent,
    SliderHotpotComponent
  ],
  imports: [
    CommonModule,
    WidgetsModule,
    SlickCarouselModule,
    TemplateModule,
    TranslateModule,
    RouterModule.forChild(HomeRoutes)
  ]
})
export class HomeModule {
}
